import { can, type Me } from '../auth/me';

const any = (me: Me, resource: string, actions: string[]) => actions.some((a) => can(me, resource, a));

/** Which settings the user may change; the "Ustawienia firmy" menu entry shows when any of them is true. */
export function canManageSettings(me: Me): { warehouse: boolean; venues: boolean; systems: boolean; checklists: boolean; stageTypes: boolean; exports: boolean; taskRepeats: boolean; gus: boolean; box: boolean; any: boolean } {
  const warehouse = can(me, 'events.settings', 'edit');
  // spec 2026-10-22-mapy-google: "Miejsca wydarzeń" with their notes for the crew
  const venues = any(me, 'events.venues', ['create', 'edit', 'delete']);
  const systems = any(me, 'events.systems', ['create', 'edit', 'delete']);
  const checklists = any(me, 'planning.checklist_presets', ['create', 'edit', 'delete']);
  const stageTypes = any(me, 'schedule.settings', ['create', 'edit', 'delete']);
  // P11 "Eksport danych": downloading is the owner's; the history of downloads can be given to others
  const exports = me.isOwner || can(me, 'backup.downloads', 'view');
  // owner 2026-10-24 01:38: "Powiadomienia" — repeats of the task notifications
  const taskRepeats = can(me, 'company_tasks.settings', 'view');
  // owner 2026-11-03: the GUS (API REGON) key, the owner's only (like the KSeF token)
  const gus = me.isOwner;
  // owner 2026-11-03: Box (the app's credentials and the folder for invoices), the owner's only (like the GUS key)
  const box = me.isOwner;
  return { warehouse, venues, systems, checklists, stageTypes, exports, taskRepeats, gus, box, any: warehouse || venues || systems || checklists || stageTypes || exports || taskRepeats || gus || box };
}
